// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSteps-List_cls1__9sw-R","cls2":"VeloSteps-List_cls2__zxSVF VeloSteps-List_cls1__9sw-R"};